import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { FieldWriteNumberComponent } from './../../field-write-number.component'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Animations } from '../../../../Animations';
import { from } from 'rxjs';
import * as settings from './../../../../common/settings';
import * as Units from './../../../../common/units';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-distance-field-w',
  templateUrl: './distance-field-w.component.html',
  styleUrls: ['./../../Field-Styles.scss'],
  animations: [
    Animations.BlinkRedError
  ]
})
export class DistanceFieldWComponent extends FieldWriteNumberComponent implements OnInit {
  @Input() public units: settings.DisplayUnits;
  unitsText: string = "";

  constructor(fb: FormBuilder, translateService: TranslateService) {
    super(fb, translateService);
    this.units = settings.userSettings.displayUnits;
    this.fixUnitsText();

    settings.userSettings.displayUnitsSub.subscribe(x => {
      this.changeUnits(x);
    });

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.fixUnitsText();
    });
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public getValue(): number {
    if (this.Disable)
      return undefined;
    let val =  super.getValue();
    if (this.units == settings.DisplayUnits.Imperial && val != undefined)
      return val * Units.METER_TO_FEET;
    return val;
  }

  public changeUnitsClick() {
    if (this.Disable)
      return;
    this.changeUnits();
  }

  public changeUnits(units?: settings.DisplayUnits) {
    if (units != undefined)
      this.units = units;
    else
      this.units = settings.nextDisplayUnit(this.units);
    this.fixUnitsText();
    this.fixInputUnits();
  }

  public fixUnitsText() {
    switch (this.units) {
      case settings.DisplayUnits.Imperial:
        this.unitsText = this.translateService.instant("UNITS.FEET");
        if (this.Form)
          if (this.checkValValid(this.Form.controls.Field.value))
            this.Form.controls.Field.setValue((this.Form.controls.Field.value * Units.METER_TO_FEET).toFixed(this.MaxNumsAfterDot));
        break;

      case settings.DisplayUnits.Metric:
        this.unitsText = this.translateService.instant("UNITS.METER");
        if (this.Form)
          if (this.checkValValid(this.Form.controls.Field.value))
            this.Form.controls.Field.setValue((this.Form.controls.Field.value * Units.FEET_TO_METER).toFixed(this.MaxNumsAfterDot));
        break;

      default:
        break;
    }
  }

  public fixInputUnits() {
    switch (this.units) {
      case settings.DisplayUnits.Imperial:
        this.Validator = [Validators.required];
        if (this.MaxVal != undefined)
          this.Validator.push(Validators.max(this.MaxVal * Units.METER_TO_FEET));
        if (this.MinVal != undefined)
          this.Validator.push(Validators.min(this.MinVal * Units.METER_TO_FEET));
        break;

      case settings.DisplayUnits.Metric:
        this.Validator = [Validators.required];
        if (this.MaxVal != undefined)
          this.Validator.push(Validators.max(this.MaxVal));
        if (this.MinVal != undefined)
          this.Validator.push(Validators.min(this.MinVal));
        break;

      default:
        break;
    }

    let val = '';
    if (this.Form)
      val = this.Form.controls.Field.value;
    this.Form = this.fb.group({
      Field: [val, this.Validator],
    });
  }

  transVal(val: number): number {
    if (val == undefined)
      return undefined;
    return val * Units.METER_TO_FEET;
  }
}
